import { httpClient } from "@/services/http/client";

export type StudentDashboardCourse = {
  enrollmentId: string;
  courseId: string;
  courseSlug: string;
  courseTitle: string;
  enrolledAt: string;
  status: "active" | "completed" | "revoked";
  totalLessons: number;
  completedLessons: number;
  progressPercent: number;
  certificateId: string | null;
  certificateNumber: string | null;
};

export async function fetchStudentDashboard(): Promise<{ courses: StudentDashboardCourse[] }> {
  const res = await httpClient.get<{ data: { courses: StudentDashboardCourse[] } }>(
    "/v1/student/dashboard",
  );
  return res.data.data;
}
